module.exports = __webpack_public_path__ + "static/media/gold_cash.69b22e68.png";